import httpRequest from "@/services/httpRequest"

export default ({
  namespaced: true,
  state: {
    isLoading: false,
    errorMessage: null,
    page: 1,
    rows: 20,
    filter: {},
    student: [],
    filterOptions: null,
    evaluationList: [],
    evaluationTitle: [],
    evaluationScore: [],
    evaluationItem: {
      classroom: {
        name: 'VII A'
      },
      subject: {
        name: 'Matematika'
      }
    },
    evaluationTitleItem: {},
    summaryImportScore: {},
  },
  getters: {
    keyValueFilter: (state) => {
      let filter = {
        semesters: [{
          key: '',
          label: 'Semua Semester',
        }],
        classrooms: [{
          key: '',
          label: 'Semua Kelas',
        }],
        subjects: [{
          key: '',
          label: 'Semua Mata Pelajaran',
        }],
      }

      if (state.filterOptions !== null) {
        state.filterOptions.semesters.forEach((semester) => {
          const oddeven = semester.semester % 2 === 0 ? 'Genap' : 'Ganjil'
          filter.semesters.push({
            key: semester.id,
            label: `TA ${semester.year} ${oddeven}`,
          })
        })

        state.filterOptions.classrooms.forEach((classroom) => {
          filter.classrooms.push({
            key: classroom.id,
            label: classroom.name
          })
        })

        state.filterOptions.subjects.forEach((subject) => {
          filter.subjects.push({
            key: subject.code,
            label: subject.name
          })
        })
      }
      return filter;
    },
    getEvaluationTitle: (state) => (id) => {
      id = parseInt(id);
      let ret = null;
      for (const et of state.evaluationTitle) {
        if (et.id === id) {
          ret = et;
          break
        }
      }
      return ret
    }
  },
  mutations: {
    // --- Status Loading dan Error ---
    SET_IS_LOADING(state, status) {
      state.isLoading = status;
    },
    SET_ERROR_MESSAGE(state, message) {
      state.errorMessage = message;
    },
    CLEAR_ERROR_MESSAGE(state) {
      state.errorMessage = null;
    },

    // --- Filter ---
    SET_FILTER_OPTIONS(state, data) {
      state.filterOptions = data;
    },

    // --- Data ---
    SET_STUDENTS(state, data) {
      state.students = data;
    },
    SET_EVALUATION_LIST(state, data) {
      state.evaluationList = data;
    },
    SET_EVALUATION_TITLE(state, data) {
      state.evaluationTitle = data;
    },
    SET_EVALUATION_SCORE(state, data) {
      state.evaluationScore = data;
    },
    SET_EVALUATION_ITEM(state, data) {
      state.evaluationItem = data;
    },
    SET_EVALUATION_TITLE_ITEM(state, data) {
      state.evaluationTitleItem = data;
    },
    SET_SUMMARY_IMPORT_SCORE(state, data) {
      state.summaryImportScore = data;
    },
  },
  actions: {
    async getStudents({ rootState, commit }, id) {
      commit("SET_IS_LOADING", true);
      commit("CLEAR_ERROR_MESSAGE");

      try {
        const payload = {
          options: {
            url: `${rootState.baseURL}/api/v1/classroom/${id}/students`,
            method: 'GET',
          },
          authorized: true
        }
        const response = await httpRequest(payload)
        if (response.status === 200) {
          const data = response.data;
          await commit('SET_STUDENTS', data)
        } else {
          const errorMessage = `Gagal mengambil Data: ${response.status} - ${response.statusText || 'Terjadi kesalahan'}`;
          commit("SET_ERROR_MESSAGE", errorMessage);
        }
      } catch (error) {
        const errorMessage = `Terjadi kesalahan jaringan saat mengambil Data: ${error.message}`;
        commit("SET_ERROR_MESSAGE", errorMessage);
      } finally {
        commit("SET_IS_LOADING", false)
      }
    },
    async getFilterOptions({ rootState, commit }) {
      commit("SET_IS_LOADING", true);
      commit("CLEAR_ERROR_MESSAGE");
      try {
        const payload = {
          options: {
            url: `${rootState.baseURL}/api/v1/evaluation/get_filter_options`,
            method: 'GET',
          },
          authorized: true
        };
        const response = await httpRequest(payload);

        if (response.status === 200) {
          const data = response.data;
          commit("SET_FILTER_OPTIONS", data);
          // commit("home/SET_FILTER_DATA", data, { root: true });
        } else {
          const errorMessage = `Gagal mengambil Data: ${response.status} - ${response.statusText || 'Terjadi kesalahan'}`;
          commit("SET_ERROR_MESSAGE", errorMessage);
        }
      } catch (error) {
        const errorMessage = `Terjadi kesalahan jaringan saat mengambil Data: ${error.message}`;
        commit("SET_ERROR_MESSAGE", errorMessage);
      } finally {
        commit("SET_IS_LOADING", false);
      }
    },
    async getTasks({ rootState, commit }, param) {
      commit("SET_IS_LOADING", true);
      commit("CLEAR_ERROR_MESSAGE");
      try {
        const payload = {
          options: {
            url: `${rootState.baseURL}/api/v1/studypost`,
            method: 'GET',
            params: param
          },
          authorized: true
        };
        const response = await httpRequest(payload);

        if (response.status === 200) {
          return response.data;
        } else {
          const errorMessage = `Gagal mengambil Data: ${response.status} - ${response.statusText || 'Terjadi kesalahan'}`;
          commit("SET_ERROR_MESSAGE", errorMessage);
        }
      } catch (error) {
        const errorMessage = `Terjadi kesalahan jaringan saat mengambil Data: ${error.message}`;
        commit("SET_ERROR_MESSAGE", errorMessage);
      } finally {
        commit("SET_IS_LOADING", false);
      }
    },
    async getEvaluation({ rootState, state, commit }) {
      commit("SET_IS_LOADING", true);
      commit("CLEAR_ERROR_MESSAGE");
      // let query = '';
      // if (exclude) {
      //   state.filter = state.filter
      // }

      try {
        const payload = {
          options: {
            url: `${rootState.baseURL}/api/v1/evaluation`,
            method: 'GET',
            params: state.filter
          },
          authorized: true
        };
        const response = await httpRequest(payload);

        if (response.status === 200) {
          const data = response.data?.results || [];
          commit("SET_EVALUATION_LIST", data);
        } else {
          const errorMessage = `Gagal mengambil Data: ${response.status} - ${response.statusText || 'Terjadi kesalahan'}`;
          commit("SET_ERROR_MESSAGE", errorMessage);
        }
      } catch (error) {
        const errorMessage = `Terjadi kesalahan jaringan saat mengambil Data: ${error.message}`;
        commit("SET_ERROR_MESSAGE", errorMessage);
      } finally {
        commit("SET_IS_LOADING", false);
      }
    },
    async getEvaluationTitle({ rootState, state, commit }, params) {
      commit("SET_IS_LOADING", true);
      commit("CLEAR_ERROR_MESSAGE");
      try {
        const payload = {
          options: {
            url: `${rootState.baseURL}/api/v1/evaluationtitle`,
            method: 'GET',
            params: params
          },
          authorized: true
        };
        const response = await httpRequest(payload);

        if (response.status === 200) {
          const data = response.data?.results || [];
          commit("SET_EVALUATION_TITLE", data);
        } else {
          const errorMessage = `Gagal mengambil Data: ${response.status} - ${response.statusText || 'Terjadi kesalahan'}`;
          commit("SET_ERROR_MESSAGE", errorMessage);
        }
      } catch (error) {
        const errorMessage = `Terjadi kesalahan jaringan saat mengambil Data: ${error.message}`;
        commit("SET_ERROR_MESSAGE", errorMessage);
      } finally {
        commit("SET_IS_LOADING", false);
      }
    },
    async createEvaluationTitle({ rootState, state, commit }, data) {
      commit("SET_IS_LOADING", true);
      commit("CLEAR_ERROR_MESSAGE");
      try {
        const payload = {
          options: {
            url: `${rootState.baseURL}/api/v1/evaluationtitle`,
            method: 'POST',
            data: data
          },
          authorized: true
        };
        const response = await httpRequest(payload);

        if (response.status === 200 || response.status === 201) {
          const data = response.data;
          commit("SET_EVALUATION_TITLE_ITEM", data);
        } else {
          const errorMessage = `Judul evaluasi sudah ada. Gunakan judul lain.`;
          commit("SET_ERROR_MESSAGE", errorMessage);
        }
      } catch (error) {
        const errorMessage = `Terjadi kesalahan jaringan saat mengambil Data`;
        commit("SET_ERROR_MESSAGE", errorMessage);
      } finally {
        commit("SET_IS_LOADING", false);
      }
    },
    async editEvaluationTitle({ rootState, state, commit }, param) {
      commit("CLEAR_ERROR_MESSAGE");
      try {
        const payload = {
          options: {
            url: `${rootState.baseURL}/api/v1/evaluationtitle/${param.id}`,
            method: 'PATCH',
            data: param.data
          },
          authorized: true
        };
        const response = await httpRequest(payload);

        if (response.status === 200 || response.status === 201) {
          const data = response.data;
          commit("SET_EVALUATION_TITLE_ITEM", data);
        } else {
          const errorMessage = `Judul evaluasi sudah ada. Gunakan judul lain.`;
          commit("SET_ERROR_MESSAGE", errorMessage);
        }
      } catch (error) {
        const errorMessage = `Terjadi kesalahan jaringan`;
        commit("SET_ERROR_MESSAGE", errorMessage);
      }
    },
    async deleteEvaluationTitle({ rootState, state, commit }, id) {
      commit("SET_IS_LOADING", true);
      commit("CLEAR_ERROR_MESSAGE");
      try {
        const payload = {
          options: {
            url: `${rootState.baseURL}/api/v1/evaluationtitle/${id}`,
            method: 'DELETE',
          },
          authorized: true
        };
        const response = await httpRequest(payload);

        if (response.status === 200 || response.status === 201) {
          const data = response.data;
        } else {
          const errorMessage = `Gagal mengambil Data: ${response.status} - ${response.statusText || 'Terjadi kesalahan'}`;
          commit("SET_ERROR_MESSAGE", errorMessage);
        }
      } catch (error) {
        const errorMessage = `Terjadi kesalahan jaringan saat mengambil Data: ${error.message}`;
        commit("SET_ERROR_MESSAGE", errorMessage);
      } finally {
        commit("SET_IS_LOADING", false);
      }
    },
    async importScore({ rootState, state, commit }, param) {
      commit("SET_IS_LOADING", true);
      commit("CLEAR_ERROR_MESSAGE");
      try {
        const payload = {
          options: {
            url: `${rootState.baseURL}/api/v1/evaluationtitle/${param.id}/import_scores`,
            method: 'POST',
            data: param.data
          },
          authorized: true
        };
        const response = await httpRequest(payload);

        if (response.status === 200) {
          const data = response.data;
          // return data;
          commit("SET_SUMMARY_IMPORT_SCORE", data);
        } else {
          const errorMessage = `Gagal mengambil Data: ${response.status} - ${response.statusText || 'Terjadi kesalahan'}`;
          commit("SET_ERROR_MESSAGE", errorMessage);
        }
      } catch (error) {
        const errorMessage = `Terjadi kesalahan jaringan saat mengambil Data: ${error.message}`;
        commit("SET_ERROR_MESSAGE", errorMessage);
      } finally {
        commit("SET_IS_LOADING", false);
      }
    },
    async getEvaluationScore({ rootState, commit }, params) {
      commit("SET_IS_LOADING", true);
      commit("CLEAR_ERROR_MESSAGE");
      try {
        const payload = {
          options: {
            url: `${rootState.baseURL}/api/v1/evaluationstudentscore`,
            method: 'GET',
            params: params,
          },
          authorized: true
        };
        const response = await httpRequest(payload);

        if (response.status === 200) {
          const data = response.data?.results || [];
          commit("SET_EVALUATION_SCORE", data);
        } else {
          const errorMessage = `Gagal mengambil Data: ${response.status} - ${response.statusText || 'Terjadi kesalahan'}`;
          // commit("SET_ERROR_MESSAGE", errorMessage);
        }
      } catch (error) {
        const errorMessage = `Terjadi kesalahan jaringan saat mengambil Data: ${error.message}`;
        // commit("SET_ERROR_MESSAGE", errorMessage);
      } finally {
        commit("SET_IS_LOADING", false);
      }
    },
    async editEvaluationScore({ rootState, commit }, param) {
      // commit("SET_IS_LOADING", true);
      // commit("CLEAR_ERROR_MESSAGE");
      try {
        const payload = {
          options: {
            url: `${rootState.baseURL}/api/v1/evaluationstudentscore/${param.id}`,
            method: 'PATCH',
            data: param.data
          },
          authorized: true
        };
        const response = await httpRequest(payload);

        if (response.status === 200) {
          return;
        } else {
          const errorMessage = `Gagal mengambil Data: ${response.status} - ${response.statusText || 'Terjadi kesalahan'}`;
          // commit("SET_ERROR_MESSAGE", errorMessage);
        }
      } catch (error) {
        const errorMessage = `Terjadi kesalahan jaringan saat mengambil Data: ${error.message}`;
        // commit("SET_ERROR_MESSAGE", errorMessage);
      } finally {
        // commit("SET_IS_LOADING", false);
      }
    },
  },
});